// src/utils/checkUserSubscription.js
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { app } from '../firebase';   // adjust to where you initialize your Firebase app

const db = getFirestore(app);

export async function checkUserSubscription(userId) {
  if (!userId) return false;

  try {
    // point at: /users/{userId}/subscriptions
    const subsCol = collection(db, 'users', userId, 'subscriptions');

    // build a query for status in ["trialing","active"]
    const subsQuery = query(
      subsCol,
      where('status', 'in', ['trialing', 'active'])
    );

    // actually run it
    const snapshot = await getDocs(subsQuery);
    return !snapshot.empty;
  } catch (err) {
    console.error(`Error checking subscriptions for ${userId}:`, err);
    return false;
  }
}
